import { Grid } from '@mui/material';
import { memo } from 'react';

import {
  convertCalculationStrategy,
  convertReportMode,
  convertStatusUrl,
} from '../../api/enumerations';
import { AssociationWOData } from '../../api/registryAssociation/types';
import { formatOnlyDate, formatReal } from '../../helpers';
import { InputTitle } from '../UI/Typography';
import { Constants } from './constants';
import { WorkOrderCard, OSLink, SmallStyledInput } from './styles';

interface WorkOrderItemProps {
  workOrderData: AssociationWOData;
}

const WorkOrderItem = memo(({ workOrderData }: WorkOrderItemProps) => {
  const navigateToWorkOrder = (): string => {
    const status = convertStatusUrl(workOrderData.status);
    return `/home/property/${workOrderData.id}/${status}`;
  };
  return (
    <WorkOrderCard container rowGap={1}>
      <OSLink to={navigateToWorkOrder()} target="blank">
        OS-{workOrderData.reference_number}
      </OSLink>
      <Grid item container rowGap={1}>
        <Grid item xs={4}>
          <InputTitle>{Constants.createdAt}</InputTitle>
          <SmallStyledInput>
            {formatOnlyDate(workOrderData.created_at)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={4}>
          <InputTitle>{Constants.evaluatedValue}</InputTitle>
          <SmallStyledInput>
            {formatReal(workOrderData.evaluated_value)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={4}>
          <InputTitle>{Constants.evaluationType}</InputTitle>
          <SmallStyledInput>
            {convertCalculationStrategy(workOrderData.calculation_strategy)}
          </SmallStyledInput>
        </Grid>
        <Grid item>
          <InputTitle>{Constants.reportType}</InputTitle>
          <SmallStyledInput>
            {convertReportMode(workOrderData.report_mode)}
          </SmallStyledInput>
        </Grid>
      </Grid>
    </WorkOrderCard>
  );
});

export default WorkOrderItem;
